import { action, makeObservable, observable, runInAction } from "mobx";

import strings from "../../../locales/strings";

const fiveMinInMs = 1000 * 60 * 5;
const loadingTime = 1000;

class RefreshModel {
  error;

  disabled;

  loading;

  constructor() {
    makeObservable(this, {
      disabled: observable,
      error: observable,
      loading: observable,
      setError: action,
      sleep: action,
      setLoading: action,
      clearErrors: action,
    });
  }

  sleep(time) {
    this.disabled = true;

    setTimeout(() => {
      runInAction(() => {
        this.disabled = false;
      });
    }, time);
  }

  setLoading(newValue) {
    if (!newValue) {
      // Искуственная задержка
      setTimeout(() => {
        runInAction(() => {
          this.loading = false;
        });
      }, loadingTime);
    } else {
      this.loading = true;
    }
  }

  clearErrors() {
    this.error = null;
  }

  setError(data) {
    if (data.error === "attempts_limit_error") {
      this.error = strings.refresh_attemptsLimitError;
      this.sleep(fiveMinInMs);
    } else {
      this.error = strings.sorrySomethingWentWrongPleaseTryAgain;
    }
  }
}

export default RefreshModel;
